export class SetPlacementsLoadingStatus {
    public static readonly type = '[JobsPlacements] Set placements loading status';
}
